const initState = {
  isFetching: false,
  openDialog: false,
  fwPackages: [],
  error: null,
};

function fwPackages(state = initState, action) {
  switch (action.type) {
    case 'CLEAR_STATE':
      return initState;
    case 'OPEN_FW_VERSIONS_CREATE_EDIT_DIALOG':
      return {
        ...state, openDialog: true, error: null, mode: action.mode,
      };
    case 'CLOSE_FW_VERSIONS_CREATE_EDIT_DIALOG':
      return { ...state, openDialog: false };
    case 'FWPACKAGE_REQUEST_SUCCESS':
      return { ...state, isFetching: false, openDialog: false };
    case 'FWPACKAGE_REQUEST_ERROR':
      return { ...state, isFetching: false, error: action.message };
    case 'FWPACKAGE_REQUEST':
      return { ...state, isFetching: true, error: null };
    default:
      return state;
  }
}

export default fwPackages;
